import { arrayMove } from '@dnd-kit/sortable';
import type { ModulesAndAgendasState } from '../index';
import { findTabIndex } from 'utils/section/tabSection';

interface Payload {
  currentTab: number;
  oldIndex: number;
  newIndex: number;
}

export const reorderSections = (state: ModulesAndAgendasState, { payload }: { payload: Payload }) => {
  const { currentTab, oldIndex, newIndex } = payload;

  const currentTabIndex = findTabIndex(state.tabSections, currentTab);
  if (currentTabIndex === -1) return;

  state.tabSections[currentTabIndex].sections = arrayMove(state.tabSections[currentTabIndex].sections, oldIndex, newIndex);
};
